import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'reactstrap'
import { CircularProgress, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import withAppconfig from '../../AppContext'
import { useUiGet } from '../../utils/useUiGet'

// Fetches signed Paytrail tokenization parameters and renders the form that
// takes the user to Paytrail's add-card page. The backend builds the redirect
// urls from the returnurl we pass (validated server-side against venue hosts).
function SaveCard({ appconfig }) {
  const uiGet = useUiGet({ appconfig })
  const history = useHistory()
  const { t } = useTranslation()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [tokenizingData, setTokenizingData] = useState(null)

  const fetchParams = () => {
    setLoading(true)
    setError(false)
    uiGet({
      q: 'getCardTokenizingParamsPc',
      customerid: appconfig.accountkey,
      returnurl: window.location.origin + appconfig.pathPrefix,
    })
      .then((response) => {
        if (!response.data || response.data.error || !response.data.postparameters) {
          setError(true)
        } else {
          setTokenizingData(response.data)
        }
        setLoading(false)
      })
      .catch(() => {
        setError(true)
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchParams()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 20 }}>
        <CircularProgress />
      </div>
    )
  }

  if (error || !tokenizingData || !tokenizingData.postparameters) {
    return (
      <div style={{ textAlign: 'center', padding: 20 }}>
        <Typography variant='body2' style={{ marginBottom: 15 }}>
          {t('card_add_failed_init')}
        </Typography>
        <Button size='sm' color='primary' onClick={() => fetchParams()}>
          {t('retry')}
        </Button>{' '}
        <Button size='sm' color='link' onClick={() => history.push(appconfig.pathPrefix + '/profile')}>
          {t('back')}
        </Button>
      </div>
    )
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <form id='addcard-form' action='https://services.paytrail.com/tokenization/addcard-form' method='post'>
        {Object.keys(tokenizingData.postparameters).map((key) => (
          <input key={key} type='hidden' name={key} value={tokenizingData.postparameters[key]} />
        ))}
        <Button type='submit' color='primary'>
          {t('save_card')}
        </Button>
      </form>
    </div>
  )
}

export default withAppconfig(SaveCard)
